const quarterRegex = /^q?([1-4])[_ -](\d{4})$/i;

export function formatQuarterLabel(qtr) {
  const match = qtr.match(quarterRegex);
  if (match) {
    const quarter = match[1];
    const year = match[2];
    return `Q${quarter}-${year}`;
  }
  return qtr;
}